'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
}), exports.ListItemRenderer = void 0;

var _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _officeUiFabricReact = require('office-ui-fabric-react');

function _interopRequireDefault(a) {
  return a && a.__esModule ? a : {
    default: a
  };
}
/** A component that will render a list of items
*/


var ListItemRenderer = exports.ListItemRenderer = function (a) {
  var b = a.items,
      c = a.itemKey,
      d = a.CustomComponent;
  if (!b.length) return null;
  var e = b.map(function (a, b) {
    var e = c ? a[c] : b;
    return _react2.default.createElement(_officeUiFabricReact.Stack.Item, {
      key: e
    }, _react2.default.createElement(d, {
      item: a
    }));
  });
  return _react2.default.createElement(_react2.default.Fragment, null, e);
};

ListItemRenderer.propTypes = {
  /** If it is an `array` of `objects`;
  ensure you pass the `itemKey` to
  set the key  for the rendered components */
  items: _propTypes2.default.array,

  /** If you have an array of Objects - for ex
  `{name: 'foo', id: '1234' }`; you can pass `id`
  as the `itemKey` and  the `item.id` will be set as
  the key for the mapped-list.
  */
  itemKey: _propTypes2.default.string,

  /** A custom component for how you want to render the list.  The component will receive the
  item as props */
  CustomComponent: _propTypes2.default.node
}, ListItemRenderer.defaultProps = {
  items: [],
  itemKey: '',
  CustomComponent: null
}, exports.default = _react2.default.memo(ListItemRenderer);